var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "fc-introduce-instructor", class: _vm.slug },
    [
      _c("h4", { staticClass: "fc-introduce-instructor__title" }, [
        _vm._v("강사 소개"),
      ]),
      _vm._v(" "),
      _c("h6", { staticClass: "fc-introduce-instructor__sub-title" }, [
        _vm._v(_vm._s(_vm.subTitle)),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "fc-introduce-instructor__columns" }, [
        _c("li", { staticClass: "fc-introduce-instructor__column" }, [
          _c("figure", { staticClass: "fc-introduce-instructor__icon" }, [
            _c("img", {
              attrs: {
                src:
                  _vm.slug === "data_online_fin"
                    ? _vm.InstructorImg01
                    : _vm.InstructorImg02,
                alt: "",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "fc-introduce-instructor__contents" }, [
            _c("span", { staticClass: "fc-introduce-instructor__title" }, [
              _vm._v(_vm._s(_vm.name)),
            ]),
            _vm._v(" "),
            _c("p", {
              staticClass: "fc-introduce-instructor__content",
              domProps: { innerHTML: _vm._s(_vm.career) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "fc-introduce-instructor__column" }, [
          _c("span", { staticClass: "fc-introduce-instructor__title" }, [
            _vm._v("강사님 한마디"),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "fc-introduce-instructor__content" }, [
            _vm._v(_vm._s(_vm.mention)),
          ]),
        ]),
        _vm._v(" "),
        _vm.link
          ? _c(
              "a",
              {
                staticClass: "fc-introduce-instructor__button btn",
                attrs: { href: _vm.link, target: "_blank" },
              },
              [_vm._v("강사님 인터뷰 >")]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }